import React, { useState, useEffect } from "react";
import { Button, Space, Result } from "antd";
import { DashboardOutlined, LockOutlined } from "@ant-design/icons";
import ColombiaMapComponent from "../Maps/MapsInicial";
import DashboardInicial from "../DashboardInicial/DashboardInicial";
import TwoFactorSetupModal from "../Login/TwoFactorSetupModal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setTwoFactorRequired } from "../../store/auth/authSlice";
import ColombiaMapSostenibilidadComponent from "../Maps/MapSostenibilidad";

import { selectAppPermissions } from "../../store/auth/selectors";
import ColombiaMapCombinadoComponent from "../Maps/ColombiaMapCombinadoComponent";

function Inicio() {
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [show2FAModal, setShow2FAModal] = useState(false);

  const appNamePaati = "dashboard-paati";
  const permissionsPaati = useSelector((state) =>
    selectAppPermissions(state, appNamePaati)
  );
  const permissionAccessPaati = permissionsPaati.priv_access === "Y";

  const appNameSostenibilidad = "dashboard-sostenibilidad";
  const permissionsSostenibilidad = useSelector((state) =>
    selectAppPermissions(state, appNameSostenibilidad)
  );
  const permissionAccesoSostenibilidad =
    permissionsSostenibilidad.priv_access === "Y";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const appNameSostenibilidadPaati = "informe-sostenibilidad-patti";
  const permissionsSostenibilidadPaati = useSelector((state) =>
    selectAppPermissions(state, appNameSostenibilidadPaati)
  );
  const permissionAccesoInformeSostenibilidadPatti =
    permissionsSostenibilidadPaati.priv_access === "Y";

  const { loading, user, applications, error, twoFactorRequired } = useSelector(
    (state) => state.auth
  );

  // Determinar si el usuario tiene al menos un acceso
  const hasAnyAccess = permissionAccessPaati || permissionAccesoSostenibilidad;

  useEffect(() => {
    if (!selectedComponent && hasAnyAccess) {
      if (permissionAccesoInformeSostenibilidadPatti) {
        setSelectedComponent("map-sostenibilidad-paati");
      }else if (permissionAccessPaati) {
        setSelectedComponent("map-paati");
      } else if (permissionAccesoSostenibilidad) {
        setSelectedComponent("map-sostenibilidad");
      } 
    }
  }, [
    permissionAccessPaati,
    permissionAccesoSostenibilidad,
    permissionAccesoInformeSostenibilidadPatti,
    hasAnyAccess,
    selectedComponent,
  ]);

  useEffect(() => {
    if (user && twoFactorRequired) {
      setShow2FAModal(false);
    }
  }, [user, twoFactorRequired]);

  useEffect(() => {
    if (user && user.username) {
      if (applications && applications.length === 0) {
        // Puedes mostrar notificación si se desea
      } else {
        navigate("/inicio");
      }
    } else if (error) {
      // Manejo de error
    }
  }, [user, error, applications, navigate]);

  const open2FAModal = () => setShow2FAModal(true);
  const close2FAModal = () => setShow2FAModal(false);

  const handle2FASuccess = () => {
    dispatch(setTwoFactorRequired(true));
    navigate("/inicio");
  };

  // Si no tiene acceso a ninguna aplicación
  if (!hasAnyAccess) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
          padding: "20px",
        }}
      >
        <Result
          icon={<LockOutlined style={{ fontSize: "72px", color: "#faad14" }} />}
          title="Sin Acceso a Aplicaciones"
          subTitle="No tienes permisos para acceder a ninguna de las aplicaciones disponibles. Por favor, contacta al administrador del sistema para solicitar acceso."
          extra={
            !twoFactorRequired && (
              <Button type="primary" onClick={open2FAModal}>
                Activar 2FA
              </Button>
            )
          }
        />
        <TwoFactorSetupModal
          show={show2FAModal}
          handleClose={close2FAModal}
          onSuccess={handle2FASuccess}
        />
      </div>
    );
  }

  return (
    <>
      <div style={{ textAlign: "center", padding: "10px" }}>
        <Space style={{ marginBottom: "20px" }}>
          <Button
            type="primary"
            icon={<DashboardOutlined />}
            onClick={() => setSelectedComponent("map-paati")}
            style={{
              paddingTop: "2px",
              backgroundColor:
                selectedComponent === "map-paati" ? "#52C41A" : "",
              borderColor: selectedComponent === "map-paati" ? "#52C41A" : "",
            }}
            disabled={!permissionAccessPaati}
          >
            PAATI
          </Button>

          <Button
            type="primary"
            icon={<DashboardOutlined />}
            onClick={() => setSelectedComponent("map-sostenibilidad")}
            style={{
              paddingTop: "2px",
              backgroundColor:
                selectedComponent === "map-sostenibilidad" ? "#52C41A" : "",
              borderColor:
                selectedComponent === "map-sostenibilidad" ? "#52C41A" : "",
            }}
            disabled={!permissionAccesoSostenibilidad}
          >
            Sostenibilidad
          </Button>

          <Button
            type="primary"
            icon={<DashboardOutlined />}
            onClick={() => setSelectedComponent("map-sostenibilidad-paati")}
            style={{
              paddingTop: "2px",
              backgroundColor:
                selectedComponent === "map-sostenibilidad-paati"
                  ? "#52C41A"
                  : "",
              borderColor:
                selectedComponent === "map-sostenibilidad-paati"
                  ? "#52C41A"
                  : "",
            }}
            disabled={!permissionAccesoInformeSostenibilidadPatti}
          >
            Consolidado
          </Button>

          {!twoFactorRequired && (
            <Button
              type="default"
              onClick={open2FAModal}
              style={{ paddingTop: "2px" }}
            >
              Activar 2FA
            </Button>
          )}
        </Space>
        <div>
          {selectedComponent === "map-paati" && <ColombiaMapComponent />}
          {selectedComponent === "map-sostenibilidad" && (
            <ColombiaMapSostenibilidadComponent />
          )}
          {selectedComponent === "map-sostenibilidad-paati" && (
            <ColombiaMapCombinadoComponent />
          )}
        </div>
        <TwoFactorSetupModal
          show={show2FAModal}
          handleClose={close2FAModal}
          onSuccess={handle2FASuccess}
        />
      </div>
    </>
  );
}

export default Inicio;
